import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import Account from './General/Account';
import ChangePassword from './General/ChangePassword';

const tabs = [
  {
    name: 'General',
    settings: '',
    menus: [
      {
        name: 'Account',
        component: <Account />,
      },
      {
        name: 'Change Password',
        component: <ChangePassword />,
      },
    ],
  },
];

const Setting = ({ history, location: { search } }) => {
  const params = qs.parse(search);
  const requestedTab = tabs.find((tab) => tab.name === params.tab);
  const initialTab = requestedTab || tabs[0];
  const initialMenu =
    initialTab.menus.find((menu) => menu.name === params.menu) ||
    initialTab.menus[0];

  const [activeTab, setActiveTab] = useState(initialTab);
  const [activeMenu, setActiveMenu] = useState(initialMenu);

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    setActiveMenu(tab.menus[0]);

    history.push({
      pathname: `/setting`,
      search: qs.stringify({
        ...params,
        menu: tab.menus[0].name,
        tab: tab.name,
      }),
    });
  };

  const handleChangeMenu = (menu) => {
    setActiveMenu(menu);

    history.push({
      pathname: `/setting`,
      search: qs.stringify({
        ...params,
        menu: menu.name,
        tab: activeTab.name,
      }),
    });
  };

  return (
    <div
      className="container-fluid"
      style={{ paddingLeft: '2rem', paddingRight: '2rem' }}
    >
      <div className="border-bottom pb-2 py-2 d-flex align-items-center">
        <h6 className="flex-grow-1 pt-4" style={{ color: '#A6478E' }}>
          Settings
        </h6>
      </div>
      <div className="d-flex align-items-start">
        <div
          className="d-flex flex-column flex-grow-1"
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        >
          <div
            className="d-flex justify-content-start"
            style={{ minWidth: 0, maxWidth: '100vw', overflowX: 'auto' }}
          >
            {tabs.map((tab, index) => (
              <div
                key={index}
                className="pb-3 flex-shrink-0"
                onClick={() => handleChangeTab(tab)}
              >
                    <div
                      style={
                        activeTab.name === tab.name
                          ? {
                              cursor: 'pointer',
                              marginRight: '1.5rem',
                              paddingBottom: '1rem',
                              marginBottom: '1rem',
                              borderBottom: '5px #A6478E solid',
                            }
                          : {
                              cursor: 'pointer',
                              marginRight: '1.5rem',
                              paddingBottom: '1rem',
                              marginBottom: '1rem',
                            }
                      }
                    >
                      <span
                        className={
                          activeTab.name === tab.name
                            ? 'text-brand'
                            : 'text-muted'
                        }
                      >
                        {tab.name}
                      </span>
                    </div>
              </div>
            ))}
          </div>
          {tabs.map(
            (tab) =>
              tab.name === activeTab.name && (
                <div key={tab.name} className="rounded d-flex adjust-shadow">
                  <div
                    style={{
                      width: '15rem',
                      backgroundColor: '#5e5e5e',
                    }}
                    className="border-right"
                  >
                    {activeTab.menus.map((menu) => (
                      <div
                        key={menu.name}
                        className={`p-4 ${
                          activeMenu === menu
                            ? ` bg-brand fw-semibold`
                            : `text-white`
                        }`}
                        onClick={() => handleChangeMenu(menu)}
                        style={{ cursor: 'pointer' }}
                      >
                        {menu.name}
                      </div>
                    ))}
                  </div>
                  <div className="flex-grow-1 bg-white">
                    {activeMenu.component}
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Setting);
